/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { PitrRestoreWindow } from '../models/PitrRestoreWindow';

export class PitrRestoreVaultWindows {
  /**
  * Eon-assigned ID of the backup vault.
  */
  'vaultId': string;
  /**
  * List of continuous time ranges within this vault that the resource can be restored to. Multiple ranges indicate gaps in PITR coverage (e.g., due to retention expiry or backup failures). 
  */
  'ranges': Array<PitrRestoreWindow>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "vaultId",
      "baseName": "vaultId",
      "type": "string",
      "format": ""
    },
    {
      "name": "ranges",
      "baseName": "ranges",
      "type": "Array<PitrRestoreWindow>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return PitrRestoreVaultWindows.attributeTypeMap;
  }

  public constructor() {
  }
}

